import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton, InputBase } from '@mui/material';
import React, { useCallback } from 'react';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  clearButton?: boolean; // Optional toggle for clear button
  inputProps?: React.ComponentProps<'input'>; // Optional override for input props
}

export default function SearchBar({
  placeholder = 'Search patients',
  value,
  onChange,
  clearButton = true,
  inputProps = {},
}: SearchBarProps) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      try {
        if (event?.target) {
          const newValue = event.target.value;
          if (typeof onChange === 'function') {
            onChange(newValue);
          }
        }
      } catch (error) {
        console.error('Error in SearchBar handleChange:', error);
      }
    },
    [onChange]
  );

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
  }, []);

  const handleClear = useCallback(() => {
    if (typeof onChange === 'function') {
      onChange('');
    }
  }, [onChange]);

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: 300,
        backgroundColor: '#DDDDDD',
        borderRadius: 16,
        height: 36,
      }}
    >
      <IconButton sx={{ p: '10px' }} aria-label="search" type="button">
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{
          'aria-label': placeholder,
          'data-testid': 'search-input',
          ...inputProps,
        }}
        value={value || ''}
        onChange={handleChange}
      />
      {clearButton && value && (
        <IconButton
          sx={{ p: '6px' }}
          aria-label="clear search"
          onClick={handleClear}
          data-testid="clear-search-button"
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
